import React, { useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'
import SydLabel from '../../../../commonDesign/SydLabel'
import SydButton from '../../../../commonDesign/Button'
import Switch from '../../../../molecules/Switch'
import { QUICK_DATE_OPTIONS } from './quickDates'

const quickDateOptions = QUICK_DATE_OPTIONS
  .filter(o => o.value !== 'Custom')
  .map(o => ({ value: o.value, label: o.label }))

const allQuickDateValues = quickDateOptions.map(o => o.value)

export { quickDateOptions }

export default function QuickDateChecklist ({ value, onChange }) {
  const enabled = useMemo(() => new Set(value ?? allQuickDateValues), [value])
  const allOn = enabled.size === quickDateOptions.length

  const handleToggle = useCallback((token) => {
    const next = new Set(enabled)
    if (next.has(token)) {
      next.delete(token)
    } else {
      next.add(token)
    }
    onChange(next.size === quickDateOptions.length ? null : Array.from(next))
  }, [enabled, onChange])

  const handleToggleAll = useCallback(() => {
    onChange(allOn ? [] : null)
  }, [allOn, onChange])

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
        <SydLabel label='Available Quick Dates' style={{ marginBottom: 0 }} />
        <SydButton variant='ghost' size='xs' onClick={handleToggleAll}>
          {allOn ? 'Disable All' : 'Enable All'}
        </SydButton>
      </div>
      <div style={{
        maxHeight: '240px',
        overflowY: 'auto',
        border: '1px solid var(--color-neutral-200)',
        borderRadius: '6px',
        padding: '4px 0'
      }}
      >
        {quickDateOptions.map(opt => (
          <div
            key={opt.value}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '3px 10px',
              fontSize: 'var(--font-size-sm)'
            }}
          >
            <span>{opt.label}</span>
            <Switch
              checked={enabled.has(opt.value)}
              onChange={() => handleToggle(opt.value)}
            />
          </div>
        ))}
      </div>
    </div>
  )
}

QuickDateChecklist.propTypes = {
  value: PropTypes.array,
  onChange: PropTypes.func.isRequired
}
